import "./Contact.module.css";
import Navigation from "@/reusable_sections/Header";
import Planning from "./sections/Planning";
import Location from "./sections/Location";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Navigation />
      <Planning />
      <Location />
      <Contact />
      <Footer />
    </div>;
}